import { ThemePreview } from '@/components';

const ThemePreviewPage: React.FC = () => {
    return <ThemePreview />;
};

export default ThemePreviewPage;
